/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { SUBMIT_KYC_DATA } from '@pages/BuyInsurancePage/apis/graphql';

import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { vappContainer } from '@/application';

export interface IKYCSubmitProps {
  firstName?: string;
  lastName?: string;
  streetAddress?: string;
  city?: String;
  country?: string;
  telephone?: string;
  occupation?: string;
  addressProofType?: string;
  idProofType?: string;
  addressProof?: any;
  idProof?: any;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IKYCSubmitMethods extends IPluginMethodMap {
  getKYCSubmitProps(args: IKYCSubmitProps): Promise<any>;
}

export class KYCSubmitPlugin implements IAgentPlugin {
  readonly methods: IKYCSubmitMethods;

  constructor() {
    this.methods = {
      getKYCSubmitProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IKYCSubmitProps) {
    console.log(`args in kyc submit`, args);
    return await this.submitKyc(args);
  }

  private async submitKyc(args: any) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      // const token = "eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InNoYXJtYXBvb2phOTc4M0BnbWFpbC5jb20iLCJ2dWlkIjoiOTc1MDk2OTU4OTU4IiwiY3VycmVudFJvbGUiOnsibmFtZSI6InB1cmNoYXNlciIsInV1aWQiOiJkZTNjNzkxMi0zYTUyLTQxYzgtOWEzNC1iYzBmMDU4ZjQwOTciLCJhdXRoVHlwZSI6IlBBU1NXT1JEIn0sImlhdCI6MTY4NzI4NzIyOSwiZXhwIjoxNjg3NDYwMDI5LCJhdWQiOiJib2lsZXJwbGF0ZS52bGluZGVyLmlvIiwiaXNzIjoidmxpbmRlciIsInN1YiI6Ijk3NTA5Njk1ODk1OCIsImp0aSI6IjdmMmUwNzEwLTYzMjktNDVmNi04ZGZmLTgwYTBjMDhjNmQ5NSJ9.QrNPufB6q1GgmYBsrp2wT4brcYsn-CdJXuePFRE4wkK7nPIT2CrL0g9E6Q41N_Is99zM176VKzgtmHQeinyJfQOWIrdSWEtAZlMtiPpEOaBXJT4O-2hTRBhItB1QnBsBHMCshZwBSZqpImSU_WpRHQh4LDmKMVcoKpjZHgnhjWk";
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .mutation(SUBMIT_KYC_DATA, {
          input: {
            firstName: args?.firstName,
            lastName: args?.lastName,
            gender: args?.gender,
            aadharNo: args?.aadharNo,
            documents: this.getDocs(args),
            address: {
              addressLine1: args?.streetAddress,
              city: args?.city,
              country: args?.country,
            },
            occupation: args?.occupation,
            primaryContactNo: args?.telephone,
          },
        })
        .toPromise();

      if (res?.data) {
        return res?.data;
      }
    } catch (err: any) {
      throw err;
    }
  }

  private getDocs(args: any) {
    let _docs = [];
    if (args?.addressProofType && args?.addressProof) {
      _docs.push({
        doc: args?.addressProof[0]?.base64,
        type: 'ADDRESS_PROOF',
        name: args?.addressProofType,
      });
    }
    if (args?.idProofType && args?.idProof) {
      _docs.push({
        doc: args?.idProof[0]?.base64,
        type: 'ID_PROOF',
        name: args?.idProofType,
      });
    }
    // if(args?.healthReport){
    //   _docs.push({
    //     doc:args?.healthReport[0]?.base64,
    //     type:'HEALT_REPORT',
    //     name:'Health Report'
    //   });
    // }
    return _docs;
  }
}
